import { Controller } from '@hotwired/stimulus';

// Monthly snapshots have no state/trim dimensions. Keep the indexed national
// reference available, but never present it as the selected cohort's history.
export default class extends Controller {
  static targets = ['status', 'reference', 'summary'];
  static values = { baselineState: String, baselineLabel: String, period: String };

  changeScope(event) {
    const { state = '', slug = 'all', stateLabel, trimLabel } = event.detail || {};
    const scoped = Boolean(state !== (this.baselineStateValue || '') || (slug && slug !== 'all'));
    this.statusTarget.hidden = !scoped;
    this.summaryTarget.hidden = !scoped;
    this.referenceTarget.open = !scoped;
    if (scoped) {
      const region = state ? (stateLabel || state) : 'the U.S.';
      const trim = slug && slug !== 'all' ? (trimLabel || slug) : 'all trims';
      const period = this.periodValue || 'Monthly price history';
      const baseline = this.baselineLabelValue || 'national history for all trims';
      this.statusTarget.textContent = `${period} is not available for ${region} · ${trim}. Explore the ${baseline} below; it does not reflect your selected filters.`;
    } else {
      this.statusTarget.textContent = '';
    }
  }
}
